<template>
   <div>
       <s-button label="GENERATE PDF" @onclick="generateReport()"/>
     <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="hee hee"
        :pdf-quality="2"
        :manual-pagination="false"
         pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
 
       
        ref="html2Pdf"
    >
        
       <slot slot="pdf-content" ></slot>
    </vue-html2pdf>
   </div>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf';

export default {
   
    methods: {
        generateReport () {
            this.$refs.html2Pdf.generatePdf()
        }
    },
 
    components: {
        VueHtml2pdf
    }
}
</script>